import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merges Tailwind classes with conflict resolution. The only class helper allowed in JSX. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
